<template>
  <div id="infoFillingPage">
    <div>
      <header>手机设备信息</header>
      <ul>
        <!--<li class="arrow">
          <div class="tit">苹果机/安卓机：</div>
          <div class="sInfo select">
            <el-select @change="selectPhoneType" v-model="phoneType" placeholder="请选择">
              <el-option
                :value="'苹果机'"
                size="small">
              </el-option>
              <el-option
                :value="'安卓机'"
                size="small">
              </el-option>
            </el-select>
          </div>
        </li>-->
        <li class="arrow">
          <div class="tit">保障手机品牌：</div>
          <div class="sInfo select">
            <el-select @change="selectMobileBrand" v-model="mobileBrand" placeholder="请选择" >
              <el-option
                v-for="item in mobileBrandList"
                :key="item"
                :label="item"
                :value="item"
                size="small">
              </el-option>
            </el-select>
          </div>
        </li>
        <li class="reminder">
          <div class="tit">保障手机型号：</div>
          <div class="sInfo">
            <input type="text" placeholder="请输入手机型号" v-model="mobileType" />
            <span class="reminder-image" @click="mobileTypeDialog = true"></span>
          </div>
        </li>
        <!--<li class="arrow">
          <div class="tit">屏幕类型：</div>
          <div class="sInfo">
            <div>请选择</div>
          </div>
        </li>-->
        <li class="reminder" style="height: 70px;">
          <div style="height: 50px">
            <div class="tit">设备IMEI：</div>
            <div class="sInfo">
              <input type="text" placeholder="请输入手机IMEI" v-model="desensitizeApdId" />
              <span class="reminder-image" @click="IMEIDialog = true"></span>
            </div>
          </div>
          <div class="important">* 理赔关键信息，请确保填写正确</div>
        </li>
        <li>
          <div class="tit">设备销售日期：</div>
          <div class="sInfo">
            <el-date-picker
              v-model="saleDate"
              type="date"
              align="center"
              size="small"
              value-format="yyyy-MM-dd"
              placeholder="请选择设备销售日期">
            </el-date-picker>
          </div>
        </li>
        <li>
          <div class="tit">手机销售订单号：</div>
          <div class="sInfo">
            <input type="text" placeholder="请输入手机销售订单号" v-model="instOrderNo" />
          </div>
        </li>
        <li>
          <div class="tit">手机价格：</div>
          <div class="sInfo" :class="cpPhoneMoney ? 'active':''">
            <div>{{cpPhoneMoney}}</div>
          </div>
        </li>
        <li>
          <div class="tit">实际价格：</div>
          <div class="sInfo">
            <input type="text" placeholder="请输入实际价格" v-model="OrderAmount" onkeyup="value=value.replace(/[^\d]/g,'')" />
          </div>
        </li>
      </ul>
    </div>
    <div>
      <header>权益人信息</header>
      <ul>
        <li>
          <div class="tit">机主姓名：</div>
          <div class="sInfo">
            <input type="text" placeholder="请输入机主姓名" v-model="insuredName" />
          </div>
        </li>
        <li>
          <div class="tit">机主身份证号：</div>
          <div class="sInfo">
            <input type="text" placeholder="请输入机主身份证号" v-model="insuredIdCard" maxlength="18" onKeyUp="value=value.replace(/[\W]/g,'')" />
          </div>
        </li>
        <li>
          <div class="tit">手机号：</div>
          <div class="sInfo">
            <input v-if="!this.$$.isValidObj(phoneNum)" type="text" placeholder="请输入手机号" maxlength="11" v-model="insuredMobile" onkeyup="value=value.replace(/[^\d]/g,'')" />
            <input v-else type="text" placeholder="请输入手机号" v-model="phoneNum" disabled />
          </div>
        </li>
      </ul>
      <div class="checked flex-start">
        <!--<el-checkbox v-model="checked">本人已阅读并知悉同意</el-checkbox>-->
        <span class="check_box whetherAgree" @click="checkeds">
          <img v-if="checked == false" class="checkbox" src="../../../../static/images/product/checkbox_no.png" data-check="0">
          <img v-if="checked == true" class="checkbox isCheck" src="../../../../static/images/product/checkbox_yes.png" data-check="1" >
        </span>
        <span>本人已阅读并知悉同意
          <span @click="rightsAgreements">《碎屏保障服务协议》</span>
        </span>
      </div>
    </div>
    <div class="claim">
      <el-button @click="submitOrder">提交</el-button>
    </div>
    <div class="explain">*广州米免网络科技有限公司为联通/联通支付公司用户权益服务支撑方</div>

    <el-dialog
      :visible.sync="mobileTypeDialog"
      width="80%"
      center>
      <div class="head">
        <div class="title">温馨提示</div>
        <img class="tipBell" src="../../../../static/images/product/brokenScreenInsurance/tipBell.png"  />
      </div>
      <div class="promptContent">
        <div>（1）安卓手机查找： </div>
        <div> 设置>关于手机>型号 </div>
        <div>（2）苹果手机查找：</div>
        <div> 设置>通用>关于手机>型号</div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="IMEIDialog"
      width="80%"
      center>
      <div class="head">
        <div class="title">温馨提示</div>
        <img class="tipBell" src="../../../../static/images/product/brokenScreenInsurance/tipBell.png"  />
      </div>
      <div class="promptContent">
        <div>（1）安卓手机查找： </div>
        <div> 设置>关于手机>IMEI </div>
        <div>（2）苹果手机查找：</div>
        <div> 设置>通用>关于手机>IMEI</div>
        <div style="color: #FA6E50;font-size: 12px;padding-left: 30px">* 如果多个，请填写IMEI1</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import myBMap from "../../../tool/baiduMapAPI";
    export default {
      name: "brokenScreenInsurance_infoFillingPage",
      data() {
        return {
          skuList: [],
          rightsToken: '',
          skuId: '',
          phoneType: '',
          //-- 手机设备信息
          mobileBrand: '',
          mobileType: '',
          applyType: 0,
          desensitizeApdId: '',
          saleDate: '',
          instOrderNo: '',
          OrderAmount: '',
          // BuyerNickName: '',
          // BuyerIdCardNo: '',
          // BuyerMobile: '',
          //-- 受益人信息
          insuredName: '',
          insuredIdCard: '',
          insuredMobile: '',
          //-- 权益数据
          phoneNum: '',
          cpPhoneMoney: '',
          //-- 弹窗提示
          mobileTypeDialog: false,
          IMEIDialog: false,
          //-- 手机品牌列表: iPhone、华为、小米、魅族、三星、OPPO、VIVO、荣耀、Realme、一加、其他
          mobileBrandList: ['iPhone', '华为保时捷系列', '各品牌折叠屏手机', '8848手机', 'VERTU手机', '华为', '小米', '魅族', '三星', 'OPPO', 'VIVO', '荣耀', 'Realme', '一加', '其他'],
          checked: false,
          messageState: null,
        }
      },
      methods: {
        checkeds(e){
          this.checked = this.checked ? false : true;
        },
        //-- 权益协议
        rightsAgreements(){
          this.$router.push({name: 'serviceAgreementPage', query: {preview: true}});
        },
        selectMobileBrand(e){
          this.mobileBrand = e;
        },
        selectPhoneType(e){
          let that = this;
          that.phoneType = e;
          that.mobileBrand = e == '苹果机' ? that.mobileBrandList[0] : '';
        },
        //-- 获取权益数据
        getRightsInfo(){
          let that = this;
          let loading = that.Loading.service({fullscreen: true});
          that.axios.post('/management/unicom/getRightsInfo', {rightsToken: that.rightsToken}).then((response) => {
            that.$nextTick(() => loading.close());
            let data = response.data;

            if (data.success) {
              const {cpPhoneMoney, phoneNum, skuList} = data.datas;
              that.skuList = skuList;
              that.cpPhoneMoney = cpPhoneMoney;
              that.phoneNum = phoneNum;
              that.insuredMobile = phoneNum;
            }else {
              that.$$.alert({
                message: data.msg,
                showClose: false,
                onOk: function () {
                  that.$router.go(-1);
                }
              });
            }
          });
        },
        //-- 领取权益
        submitOrder(){
          let that = this;
          const {rightsToken, mobileBrand, mobileType, applyType, desensitizeApdId, saleDate, instOrderNo, OrderAmount, insuredName, insuredIdCard, insuredMobile} = that;

          //-- 校验
          const errorMsg = that.validationForm();
          if(that.$$.isValidObj(errorMsg)) {
            if(that.$$.isValidObj(that.messageState)) that.messageState.close();
            that.messageState = that.$message({
              type: 'error',
              message: errorMsg,
              offset: document.documentElement.clientHeight/2
            });
            return;
          }

          // 手机设备信息
          let extendJson = {mobileBrand, mobileType, applyType, desensitizeApdId, saleDate, instOrderNo, OrderAmount, "BuyerNickName": insuredName, "BuyerIdCardNo": insuredIdCard, "BuyerMobile": insuredMobile};

          // 受益人信息
          let insuredList = [{
            insuredName,
            insuredIdCard,
            insuredMobile,
          }];

          let params = {
            "rightsToken": rightsToken,
            "extendJson": JSON.stringify(extendJson),
            "insuredList": JSON.stringify(insuredList),
            "skuId": that.skuId
          };

          // console.log(params);
          // return;

          let loading = that.Loading.service({fullscreen: true});
          that.axios.post('/management/unicom/submitOrder', params).then((response) => {
            that.$nextTick(() => loading.close());
            let data = response.data;

            if (data.success) {
              this.$$.alert({
                message: "您的权益领取申请正在审核中，请耐心等待！如有疑问请致电 <a href=\"tel:02082513114\" >020-82513114</a>",
                type: "success",
                showClose: false,
                onOk: function () {
                  that.$router.go(-1);
                }
              });
            }else {
              that.messageState = that.$message({
                type: 'error',
                message: data.msg,
                offset: document.documentElement.clientHeight/2
              });
            }
          });
        },
        //-- 校验
        validationForm(){
          let that = this;
          const {phoneType, mobileBrand, mobileType, desensitizeApdId, saleDate, instOrderNo, OrderAmount, insuredName, insuredIdCard, insuredMobile, cpPhoneMoney, checked} = that;

          // if(!that.$$.isValidObj(phoneType)) return "请选择手机机型~";
          if(!that.$$.isValidObj(mobileBrand)) return "请选择手机品牌~";
          if(!that.$$.isValidObj(mobileType)) return "请输入手机型号~";
          if(!that.$$.isValidObj(desensitizeApdId)) return "请输入手机IMEI~";
          if(!that.$$.isValidObj(saleDate)) return "请选择设备销售日期~";
          if(!that.$$.isValidObj(instOrderNo)) return "请输入手机销售订单号~";
          if(!that.$$.isValidObj(OrderAmount)) return "请输入实际价格~";

          let orderAmount = parseInt(OrderAmount);
          let cpPhoneMoneyList = cpPhoneMoney.split('-');
          if(orderAmount < cpPhoneMoneyList[0]) return `实际价格不能小于${cpPhoneMoneyList[0]}~`;
          if(orderAmount > cpPhoneMoneyList[1]) return `实际价格不能大于${cpPhoneMoneyList[1]}~`;

          // 有手机机型和实际价格 - 获取SkuId
          for (let i in that.skuList){
            let unit = that.skuList[i];
            let phoneMoneyList = unit['phoneMoney'].split('-');

            /*if (phoneType.includes(unit['phoneType']) && (orderAmount >= phoneMoneyList[0] && orderAmount <= phoneMoneyList[1])){
              that.skuId = unit['skuId'];
            }*/
            /*if (orderAmount >= phoneMoneyList[0] && orderAmount <= phoneMoneyList[1]){
              that.skuId = unit['skuId'];
            }*/

            that.skuId = unit['skuId'];
          }

          if(!that.$$.isValidObj(insuredName)) return "请输入机主姓名~";
          if (that.$$.constant.chineseNameReg.test(insuredName) === false) return "机主姓名不正确!";
          if(!that.$$.isValidObj(insuredIdCard)) return "请输入机主身份证号~";
          if (that.$$.constant.beInsureIdTypeOneReg.test(insuredIdCard) === false) return "身份证格式不正确!";
          if(!that.$$.isValidObj(insuredMobile)) return "请输入手机号~";
          if (that.$$.constant.phoneReg.test(insuredMobile) === false) return "手机号格式不正确!";

          if(!checked) return "请阅读并同意碎屏保障服务协议~~";
        },
      },
      mounted() {
        let that = this;

        that.rightsToken = that.$route.query.rightsToken;

        //-- 获取权益数据
        if (that.$$.isValidObj(that.rightsToken)) {
          that.getRightsInfo();
        }else {
          that.$$.alert({
            message: '参数有误，请重新领取权益!',
            onOk: function () {
              that.$router.go(-1);
            }
          });
        }

        //获取百度地图 - 位置
        // myBMap.IPLocations(3).then(r => {;
        //   console.log(r);
        // });
      }
    }
</script>

<style>
  .el-message-box__wrapper{
    margin: 0 2rem;
  }

  .el-message-box__message a{
    display: inline-block!important;
    color: #ff7052;
  }
</style>
<style scoped>
  #infoFillingPage header{
    height: 50px;
    line-height: 50px;
    font-size: 15px;
    font-weight: bold;
    padding-left: 16px;
    color: #666666;
    background: #F5F5F5;
  }

  #infoFillingPage li{
    height: 50px;
    min-height: 50px;
    padding: 0 16px;
    font-size: 14px;
    border-bottom: 1px solid #F2F4F7;
    position: relative;
  }

  .tit {
    width: 40%;
    height: 100%;
    letter-spacing: 1px;
    float: left;
    display: flex;
    align-items: center
  }

  .sInfo {
    width: 59%;
    height: 100%;
    color: #CCCCCC;
    float: right;
    text-align: right;
    display: flex;
    align-items: center;
  }
  .sInfo div{
    width: 100%;
  }
  .sInfo.active{
    color: #ff7052;
  }

  .arrow .sInfo{
    padding-right: 5%;
  }

  .arrow:after {
    content: '';
    position: absolute;
    right: 16px;
    top: 50%;
    margin-top: -5px;
    display: block;
    width: 10px;
    height: 10px;
    border-right: 2px solid #ff7052;
    border-bottom: 2px solid #ff7052;
    -webkit-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }

  input::-webkit-input-placeholder{
    color: #CCCCCC;
    font-weight: 400;
    font-size: 14px;
  }
  input{
    width: 100%;
    text-align: right;
    font-size: 14px;
    color: #ff7052;
  }

  .reminder input{
    width: calc(100% - 30px);
  }
  .reminder-image{
    margin-left: 18px;
    width: 12px;
    height: 12px;
    background: url("../../../../static/images/product/brokenScreenInsurance/reminder.png") no-repeat right /100% 100%;
  }
  .reminder .important{
    font-size: 12px;
    color: #FA6E50;
    font-weight: bold;
    position: absolute;
    bottom: 10px;
    left: 16px;
  }

  .sInfo /deep/ .el-input__inner {
    color: #FA6E50 !important;
    text-align: right !important;
    font-size: 14px!important;
  }

  .claim{
    width: 100%;
    height: 100px;
    padding: 30px 10%;
  }
  .claim>button{
    width: 100%;
    height: 40px;
    color: #FFFFFF;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    background: #FF7052;
    border-radius: 4px;
    border: none;
    clear: both;
  }

  /* 弹窗提示 start */
  .el-dialog__wrapper /deep/ .el-dialog{
    margin-top: 30vh!important;
    border-radius: 15px;
    position: relative;
  }

  .el-dialog__wrapper /deep/ .el-dialog__title{
    color: #FA6E50;
    font-size: 16px;
    font-weight: bold;
  }
  .el-dialog__wrapper /deep/ .el-dialog__body{
    padding: 0px!important;
    width: 100%;
    text-align: center;
    position: absolute;
    border-radius: 15px;
    top: 0;
    left: 0;
  }
  .el-dialog__wrapper /deep/ .el-dialog__headerbtn{
    z-index: 999;
  }

  .head{
    width: 100%;
    line-height: 50px;
    border-radius: 15px 15px 0 0;
    padding: 15px 0 10px;
    font-weight: bold;
    background: linear-gradient(0deg, #FFF9F8 0%, #FFE3DD 100%);
    letter-spacing: 1px;
  }
  .title{
    color: #FA6E50;
    font-size: 16px;
    display: inline-block;
    vertical-align: middle;
  }
  .tipBell{
    width: 20px;
    height: 23px;
    display: inline-block;
    vertical-align: middle;
  }

  .promptContent{
    line-height: 26px;
    padding: 10px 0 20px 15%;
    background: #FFFFFF;
    border-radius: 0 0 15px 15px;
    text-align: left;
  }
  .promptContent>div:nth-child(1),
  .promptContent>div:nth-child(3){
    color: #999999;
    font-size: 12px;
  }
  .promptContent>div:nth-child(2),
  .promptContent>div:nth-child(4){
    color: #666666;
    font-size: 13px;
    font-weight: bold;
    margin: 0 0 5px 30px;
  }
  /* 弹窗提示 end */

  .select /deep/ .el-input__inner {
    border: 0 !important;
    padding-right: 0px!important;
    background: #ffffff!important;
  }

  .select /deep/ .el-input__suffix{
    display: none;
  }

  .checked{
    line-height: 24px;
    padding: 20px 16px 0;
  }

  .check_box {
    height: 24px;
    margin-right: 5px;
  }
  .checkbox {
    width: 14px;
    display: inline-block;
  }
  .checked>span:nth-child(2){
    padding-top: 1px;
  }
  .checked>span:nth-child(2) span{
    color: #ff7052;
    width: auto;
  }

  .explain{
    width: 100%;
    padding: 0 16px 10px;
    color: #999999;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/brokenScreenInsurance/infoFillingPage.vue